import { api } from "./api";

export const getStudentReviews = async (addUrl = "") => {
  return await api.get(`student/review/list?${addUrl}`);
};
